/* =====================================================================
 * StorageFileGrid — 그리드 뷰
 * ===================================================================== */

import React from 'react';
import type { WorkspaceFile, WorkspaceItem } from '@auw/workspace-utils';
import { StorageFolderCard, StorageFileCard } from './StorageFileCard';
import { GridContainer, Grid } from './storage.styles';

interface Props {
  folders: WorkspaceItem[];
  files: WorkspaceFile[];
  folderChildCounts: Record<string, number>;
  selectedIds: Set<string>;
  onSelectFolder: (id: string) => void;
  onOpenFolder: (id: string) => void;
  onSelectFile: (id: string) => void;
  onOpenFile: (file: WorkspaceFile) => void;
  onContextMenu: (e: React.MouseEvent, type: 'folder' | 'file', id: string) => void;
}

export const StorageFileGrid: React.FC<Props> = ({
  folders,
  files,
  folderChildCounts,
  selectedIds,
  onSelectFolder,
  onOpenFolder,
  onSelectFile,
  onOpenFile,
  onContextMenu,
}) => (
  <GridContainer>
    <Grid>
      {folders.map((folder) => (
        <StorageFolderCard
          key={folder.item_id}
          folder={folder}
          childCount={folderChildCounts[folder.item_id]}
          selected={selectedIds.has(folder.item_id)}
          onClick={() => onSelectFolder(folder.item_id)}
          onDoubleClick={() => onOpenFolder(folder.item_id)}
          onContextMenu={(e) => {
            e.preventDefault();
            onContextMenu(e, 'folder', folder.item_id);
          }}
        />
      ))}
      {files.map((file) => (
        <StorageFileCard
          key={file.file_id}
          file={file}
          selected={selectedIds.has(file.file_id)}
          onClick={() => onSelectFile(file.file_id)}
          onDoubleClick={() => onOpenFile(file)}
          onContextMenu={(e) => {
            e.preventDefault();
            onContextMenu(e, 'file', file.file_id);
          }}
        />
      ))}
    </Grid>
  </GridContainer>
);
